// components/RefundProcessPopup.js
import React, { useState, useEffect } from "react";
import {
  Box,
  VStack,
  HStack,
  Text,
  Heading,
  Input,
  Select,
  Button,
  IconButton,
  useToast,
  Grid,
} from "@chakra-ui/react";
import { X, ArrowLeft, Building } from "lucide-react";
import { get_bank_list } from "../../redux/bankSlice";
import { useDispatch, useSelector } from "react-redux";
import { get_customer_detail } from "../../utils/api";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const RefundProcess = ({ 
  isOpen, 
  onClose, 
  returnData,
  calculatedAmount,
  onRefundComplete,
  initialStep = "method",
  formData, // Add this new prop
}) => {
  const [refundStep, setRefundStep] = useState(initialStep);
  const [data, setData] = useState(null);
  const [selectedRefundMethod, setSelectedRefundMethod] = useState('');
  const [refundAmount, setRefundAmount] = useState(calculatedAmount || '');
  const [paymentNotes, setPaymentNotes] = useState('');
  const [transactionMode, setTransactionMode] = useState("");
  const [transactionNumber, setTransactionNumber] = useState(""); // Add transaction number state
  const [selectedAdminBank, setSelectedAdminBank] = useState('');
  const [initialValue, setInitialValue] = useState(1);
  const [rows, setRows] = useState(1000);
  const [page, setPage] = useState(1);
  const [isProcessing, setIsProcessing] = useState(false); // Add loading state
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { bank_list, total_bank_count, hasCashInSystem } = useSelector(
    (state) => state.banks
  );

  const transactionModes = [
    {label: 'Phonepay', value: '1'},
    {label: 'GPay', value: '2'},
    {label: 'Paytm', value: '3'},
    {label: 'Cred', value: '4'},
    {label: 'RTGS', value: '6'},
    {label: 'NEFT', value: '7'},
    {label: 'IMPS', value: '8'},
    {label: 'Others', value: '5'},
  ];

  useEffect(() => {
    dispatch(get_bank_list({ page: 1, rows: 1000 })); 
    setInitialValue(1);
  }, [dispatch]);
  
  useEffect(() => {
    if (returnData?.customerid) {
      get_customer_detail(returnData.customerid, () => {})
        .then((el) => {
          if (el.success && el.data?.length > 0) {
            const customer = el.data[0];
            
            let filteredBanks = [];
            if (customer.bank?.length > 1) {
              filteredBanks = customer.bank.filter(b => b.status === "1");
            } else if (customer.bank?.length === 1) {
              filteredBanks = customer.bank;
            }
  
            setData({
              ...customer,
              filteredBanks
            });
          } else {
            console.error("Failed to fetch customer details");
          }
        })
        .catch((err) => console.error("Error fetching customer detail:", err));
    }
  }, [returnData]);

  useEffect(() => {
    if (isOpen) {  // Only update when popup is actually opened
      setRefundStep(initialStep);
      if (initialStep !== "method") {
        setSelectedRefundMethod(initialStep); // Set the selected method when going directly to a step
      }
    }
  }, [initialStep, isOpen]);

  const toast = useToast();

  const customerData = returnData ? {
    name: returnData.customer_name || "Customer",
    orderId: returnData.orderid || "#N/A",
    amount: calculatedAmount || returnData.total_amount || "0.00",
    mobile: returnData.mobile || "",
    email: returnData.email || "",
    shippingAddress: returnData.shipping_address || "",
    walletBalance: "0.00"
  } : {
    name: "Customer",
    orderId: "#N/A",
    amount: calculatedAmount || "0.00",
    mobile: "",
    email: "",
    shippingAddress: "",
    walletBalance: "0.00"
  };

  useEffect(() => {
    if (calculatedAmount) {
      setRefundAmount(calculatedAmount);
    }
  }, [calculatedAmount]);

  if (!isOpen) return null;

  const closePopup = () => {
    setRefundStep('method');
    setSelectedRefundMethod('');
    setPaymentNotes('');
    setSelectedAdminBank('');
    setTransactionMode('');
    setTransactionNumber('');
    setIsProcessing(false); // Reset processing state
    onClose();
  };

  const handleRefundMethodSelect = () => {
    if (!selectedRefundMethod) {
      toast({
        title: "Error",
        description: "Please select a refund method",
        status: "error",
        duration: 3000,
       isClosable:true,
position:"top",
      });
      return;
    }
    
    setRefundStep(selectedRefundMethod);
  };

//   // Function to prepare and submit the API request using direct axios call
//   const submitRefundApi = async (paymentMode, bankId = null, transactionNum = null) => {
//     setIsProcessing(true);
    
//     try {
//       // Prepare the FormData payload
//       const payload = new FormData();
      
//       // Basic fields
//       payload.append('action', 'update');
//       payload.append('userid', returnData.customerid); // Replace with actual user ID
//       payload.append('id', returnData.id); // Main return ID
//       payload.append('totalamount', refundAmount);
//       payload.append('narration', formData.narration || "NA");
//       payload.append('inv_date', formData.return_date || new Date().toISOString().split('T')[0]);
//       payload.append('payment_mode', paymentMode);
//       payload.append('amount', refundAmount);
//       payload.append('bank_id', bankId || ""); // Default bank ID if not provided
//       payload.append('narration', paymentNotes || "NA");

//       // Add transaction details for cash (1) or online (3) payments
//       if (paymentMode === 1 || paymentMode === 3) {
//         payload.append('transaction_number', transactionNum || "NA");
//         payload.append('mode_of_transaction', transactionMode || 1);
//       }

//       // Add product details
//       if (formData.products && formData.products.length > 0) {
//         formData.products.forEach((product, index) => {
//           payload.append(`prod_code[${index}]`, product.prod_code || "NA");
//           payload.append(`details_id[${index}]`, product.id);
//           payload.append(`quantity[${index}]`, product.return_quantity || 0);
//           payload.append(`unit_rate[${index}]`, product.unit_rate || 0);
//           payload.append(`net_weight[${index}]`, product.net_weight || 0);
//           payload.append(`taxable_amount[${index}]`, product.taxable_amount || 0);
//           payload.append(`gst[${index}]`, product.gst_percent || 0);
//           payload.append(`igst_amount[${index}]`, product.igst_amount || 0);
//           payload.append(`cgst_amount[${index}]`, product.cgst_amount || 0);
//           payload.append(`sgst_amount[${index}]`, product.sgst_amount || 0);
//           payload.append(`total_amount[${index}]`, product.amount || 0);
//           payload.append(`vehicle_id[${index}]`, product.vehicle_id || "");
//           payload.append(`reason[${index}]`, product.reason || "NA");
//           payload.append(`cyl_tare_weight[${index}]`, product.cyl_tare_weight || 0);
//           payload.append(`cyl_gross_weight[${index}]`, product.cyl_gross_weight || 0);
//         });
//       }

//       // Make the API call
//       const response = await axios.post(
//         'https://gaswale.vensframe.com/api/admin/defective_return.php',
//         payload,
//         {
//           headers: {
//             'Content-Type': 'multipart/form-data',
//           },
//         }
//       );
      
//       if (response.data && response.data.success) {
//         toast({
//           title: "Success",
//           description: "Refund processed successfully!",
//           status: "success",
//           duration: 3000,
//          isClosable:true,
// position:"top",
//         });
//         if (onRefundComplete) {
//           onRefundComplete(
//             paymentMode === 1 ? 'cash' : paymentMode === 3 ? 'online' : 'wallet', 
//             refundAmount, 
//             bankId
//           );
//         }
//         closePopup();
//       } else {
//         throw new Error(response.data?.message || "Failed to process refund");
//       }
//     } catch (error) {
//       console.error("Refund API error:", error);
      
//       let errorMessage = "Failed to process refund";
//       if (error.response) {
//         // Server responded with an error
//         errorMessage = error.response.data?.message || `Server error: ${error.response.status}`;
//       } else if (error.request) {
//         // Request was made but no response received
//         errorMessage = "Network error. Please check your connection.";
//       } else {
//         // Something else happened
//         errorMessage = error.message;
//       }
      
//       toast({
//         title: "Error",
//         description: errorMessage,
//         status: "error",
//         duration: 5000,
//        isClosable:true,
// position:"top",
//       });
//     } finally {
//       setIsProcessing(false);
//     }
//   };

  const handleCashRefund = () => {
  if (onRefundComplete) {
  onRefundComplete('cash', refundAmount, null, null, null, paymentNotes);
}
  };

  const handleOnlineTransfer = () => {
  // In handleOnlineTransfer function:
if (onRefundComplete) {
  onRefundComplete('online', refundAmount, selectedAdminBank, transactionNumber, transactionMode, paymentNotes);
}
  };

  const handleWalletCredit = () => {
// In handleWalletCredit function:
if (onRefundComplete) {
  onRefundComplete('wallet', refundAmount, selectedAdminBank, null, null, paymentNotes);
}
  };

  // Common scrollable box styles
  const scrollableBoxStyles = {
    bg: "white",
    borderRadius: "2xl",
    boxShadow: "0 20px 60px rgba(0, 0, 0, 0.15)",
    maxW: "400px",
    w: "90%",
    maxH: "70vh",
    overflowY: "auto",
    // Hide scrollbar for different browsers
    sx: {
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      '-ms-overflow-style': 'none',
      'scrollbar-width': 'none',
    }
  };

  // Render Process Refund Method Selection
  const renderRefundMethodPopup = () => (
    <Box {...scrollableBoxStyles}>
      {/* Header */}
      <Box bg="linear-gradient(135deg, #48BB78, #38A169)" p={4} color="white" position="relative"> {/* Changed to green gradient */}
        <IconButton
          icon={<X size={20} />}
          position="absolute"
          top={3}
          right={3}
          bg="rgba(255,255,255,0.2)"
          color="white"
          size="sm"
          borderRadius="full"
          onClick={closePopup}
          _hover={{ bg: "rgba(255,255,255,0.3)" }}
        />
        <VStack spacing={1} align="start">
          <Heading size="md" fontWeight="600">Process Refund</Heading> {/* Smaller heading */}
          <Text fontSize="xs" opacity={0.9}>Customer Payment Refund</Text> {/* Smaller text */}
        </VStack>
      </Box>

      {/* Content */}
      <Box p={4}> {/* Reduced padding */}
        <VStack spacing={4} align="stretch"> {/* Reduced spacing */}
          {/* Customer Details */}
          <Box>
            <Text fontSize="sm" fontWeight="600" color="gray.600" mb={2}>Customer Details</Text> {/* Reduced margin */}
            <Box bg="gray.50" p={3} borderRadius="lg"> {/* Reduced padding */}
              <VStack align="start" spacing={1}>
                <Text fontWeight="600" color="gray.800">{customerData.name}</Text>
                <Text fontSize="xs" color="gray.600">Order ID: {customerData.orderId}</Text> {/* Smaller text */}
                <Text fontSize="xs" color="gray.600">Amount: ₹{customerData.amount}</Text> {/* Smaller text */}
                <Text fontSize="xs" color="gray.600">Mobile: {customerData.mobile}</Text> {/* Smaller text */}
              </VStack>
            </Box>
          </Box>

          {/* Refund Method */}
          <Box>
            <Text fontSize="sm" fontWeight="600" color="gray.600" mb={2}>Refund Method</Text> {/* Reduced margin */}
            <Select 
              placeholder="Select refund method" 
              value={selectedRefundMethod}
              onChange={(e) => setSelectedRefundMethod(e.target.value)}
              bg="white"
              borderColor="gray.300"
              size="sm" // Smaller select
              _focus={{ borderColor: "blue.400", boxShadow: "0 0 0 1px #3182CE" }}
            >
              <option value="cash">Cash Refund</option>
              <option value="online">Online Transfer</option>
              <option value="wallet">Wallet Credit</option>
            </Select>
          </Box>

          {/* Action Buttons */}
          <HStack spacing={2}> {/* Reduced spacing */}
            <Button 
              flex={1} 
              variant="outline" 
              borderColor="gray.300"
              size="sm" // Smaller button
              onClick={closePopup}
            >
              Cancel
            </Button>
            <Button 
              flex={1} 
              bg="linear-gradient(135deg, #48BB78, #38A169)" 
              color="white"
              size="sm" // Smaller button
              _hover={{ bg: "linear-gradient(135deg, #38A169, #2F855A)" }}
              onClick={handleRefundMethodSelect}
              isLoading={isProcessing}
            >
              Continue
            </Button>
          </HStack>
        </VStack>
      </Box>
    </Box>
  );

  // Render Cash Refund Popup
  const renderCashRefundPopup = () => (
    <Box {...scrollableBoxStyles}>
      {/* Header */}
      <Box bg="linear-gradient(135deg, #48BB78, #38A169)" p={4} color="white" position="relative"> {/* Changed to green gradient */}
        <IconButton
          icon={<X size={20} />}
          position="absolute"
          top={3}
          right={3}
          bg="rgba(255,255,255,0.2)"
          color="white"
          size="sm"
          borderRadius="full"
          onClick={closePopup}
          _hover={{ bg: "rgba(255,255,255,0.3)" }}
        />
        <VStack spacing={1} align="start">
          <Heading size="md" fontWeight="600">Cash Refund</Heading> {/* Smaller heading */}
          <Text fontSize="xs" opacity={0.9}>Process cash payment to customer</Text> {/* Smaller text */}
        </VStack>
      </Box>

      {/* Content */}
      <Box p={4}> {/* Reduced padding */}
        <VStack spacing={4} align="stretch"> {/* Reduced spacing */}
          {/* Refund Amount */}
          <Box>
            <Text fontSize="sm" fontWeight="600" color="gray.600" mb={2}>Refund Amount</Text> {/* Reduced margin */}
            <Box position="relative">
              <Text 
                position="absolute" 
                left={3} 
                top="50%" 
                transform="translateY(-50%)" 
                fontSize="md" 
                fontWeight="600" 
                color="gray.500"
                zIndex={2}
              >
                ₹
              </Text>
              <Input
                pl={7}
                value={refundAmount}
                onChange={(e) => setRefundAmount(e.target.value)}
                type="number"
                step="0.01"
                fontSize="md"
                fontWeight="600"
                textAlign="right"
                bg="white"
                borderColor="gray.300"
                size="sm" // Smaller input
                _focus={{ borderColor: "blue.400", boxShadow: "0 0 0 1px #3182CE" }}
              />
            </Box>
          </Box>

          {/* Action Buttons */}
          <HStack spacing={2}> {/* Reduced spacing */}
            <Button 
              flex={1} 
              variant="outline" 
              borderColor="gray.300"
              size="sm" // Smaller button
              onClick={() => setRefundStep('method')}
              leftIcon={<ArrowLeft size={14} />} 
            >
              Back
            </Button>
            <Button 
              flex={1} 
              bg="linear-gradient(135deg, #48BB78, #38A169)" 
              color="white"
              size="sm" // Smaller button
              _hover={{ bg: "linear-gradient(135deg, #38A169, #2F855A)" }}
              onClick={handleCashRefund}
              isLoading={isProcessing}
            >
              Process Cash Refund
            </Button>
          </HStack>
        </VStack>
      </Box>
    </Box>
  );

  // Render Online Transfer Popup
  const renderOnlineTransferPopup = () => (
    <Box {...scrollableBoxStyles}>
      {/* Header */}
      <Box bg="linear-gradient(135deg, #48BB78, #38A169)" p={4} color="white" position="relative"> {/* Changed to green gradient */}
        <IconButton
          icon={<X size={20} />}
          position="absolute"
          top={3}
          right={3}
          bg="rgba(255,255,255,0.2)"
          color="white"
          size="sm"
          borderRadius="full"
          onClick={closePopup}
          _hover={{ bg: "rgba(255,255,255,0.3)" }}
        />
        <VStack spacing={1} align="start">
          <Heading size="md" fontWeight="600">Online Transfer</Heading> {/* Smaller heading */}
          <Text fontSize="xs" opacity={0.9}>Bank to bank transfer</Text> {/* Smaller text */}
        </VStack>
      </Box>

      {/* Content */}
      <Box p={4}> {/* Reduced padding */}
        <VStack spacing={4} align="stretch"> {/* Reduced spacing */}
          {/* Select Admin Bank */}
          <Box>
            <Text fontSize="sm" fontWeight="600" color="gray.600" mb={2}>Select Admin Bank</Text> {/* Reduced margin */}
            <Select 
              placeholder="Select admin bank account"
              value={selectedAdminBank}
              onChange={(e) => setSelectedAdminBank(e.target.value)} // ensure it's numeric ID
              bg="white"
              borderColor="gray.300"
              size="sm" // Smaller select
              _focus={{ borderColor: "blue.400", boxShadow: "0 0 0 1px #3182CE" }}
            >
              {bank_list && bank_list.length > 0 ? (
                bank_list
                  .filter((bank) => bank.ac_type?.toLowerCase() !== "cash")
                  .map((bank) => (
                    <option key={bank.id} value={bank.id}>
                      {bank.bankname}({bank.bank_branch}) - {bank.accountno}
                    </option>
                  ))
                  
              ) : (
                <option disabled>No banks available</option>
              )}
            </Select>
          </Box>

          {/* Customer Details */}
          <Box bg="blue.50" p={3} borderRadius="lg" border="1px solid" borderColor="blue.200"> {/* Reduced padding */}
            <HStack spacing={2} mb={2}> {/* Reduced spacing and margin */}
              <Box p={1} bg="blue.100" borderRadius="md"> {/* Reduced padding */}
                <Building size={14} color="#3182CE" /> {/* Smaller icon */}
              </Box>
              <Text fontSize="sm" fontWeight="600" color="blue.700">Customer Details</Text>
            </HStack>
            <VStack align="start" spacing={1} fontSize="xs"> {/* Smaller text */}
              <Text><strong>Name:</strong> {customerData.name}</Text>
              <Text><strong>Order ID:</strong> {customerData.orderId}</Text>
              <Text><strong>Mobile:</strong> {customerData.mobile}</Text>
              <Text><strong>Email:</strong> {customerData.email}</Text>
              {data?.filteredBanks && data.filteredBanks.length > 0 && (
                <Text>
                  <strong>Bank:</strong> {data.filteredBanks.map(b => b.bankname).join(", ")}
                </Text>
              )}
            </VStack>
          </Box>
          
          {/* Transaction Mode */}
          <Box w="100%">
            <Text fontWeight="600" mb={1} color="blue.700" fontSize="sm">Transaction Mode</Text> {/* Smaller text */}
            <Select
              placeholder="Select Transaction Mode"
              value={transactionMode}
              onChange={(e) => setTransactionMode(e.target.value)}
              bg="white"
              borderColor="gray.300"
              size="sm" // Smaller select
              _focus={{ borderColor: "blue.400", boxShadow: "0 0 0 1px #3182CE" }}
            >
              {transactionModes.map((mode) => (
                <option key={mode.value} value={mode.value}>
                  {mode.label}
                </option>
              ))}
            </Select>
          </Box>

          {/* Transaction Number */}
          <Box w="100%">
            <Text fontWeight="600" mb={1} color="blue.700" fontSize="sm">Transaction Number</Text> {/* Smaller text */}
            <Input
              placeholder="Enter transaction reference number"
              value={transactionNumber}
              onChange={(e) => setTransactionNumber(e.target.value)}
              bg="white"
              borderColor="gray.300"
              size="sm" // Smaller input
            />
          </Box>

          {/* Transfer Amount */}
          <Box>
            <Text fontSize="sm" fontWeight="600" color="gray.600" mb={2}>Transfer Amount</Text> {/* Reduced margin */}
            <Box position="relative">
              <Text 
                position="absolute" 
                left={3} 
                top="50%" 
                transform="translateY(-50%)" 
                fontSize="md" 
                fontWeight="600" 
                color="gray.500"
                zIndex={2}
              >
                ₹
              </Text>
              <Input
                pl={7}
                value={refundAmount}
                onChange={(e) => setRefundAmount(e.target.value)}
                type="number"
                step="0.01"
                fontSize="md"
                fontWeight="600"
                textAlign="right"
                bg="white"
                borderColor="gray.300"
                size="sm" // Smaller input
                _focus={{ borderColor: "blue.400", boxShadow: "0 0 0 1px #3182CE" }}
              />
            </Box>
          </Box>

          {/* Action Buttons */}
          <HStack spacing={2}> {/* Reduced spacing */}
            <Button 
              flex={1} 
              variant="outline" 
              borderColor="gray.300"
              size="sm" // Smaller button
              onClick={() => setRefundStep('method')}
              leftIcon={<ArrowLeft size={14} />}
            >
              Back
            </Button>
            <Button 
              flex={1} 
              bg="linear-gradient(135deg, #48BB78, #38A169)" 
              color="white"
              size="sm" // Smaller button
              _hover={{ bg: "linear-gradient(135deg, #38A169, #2F855A)" }}
              onClick={handleOnlineTransfer}
              isLoading={isProcessing}
            >
              Process Transfer
            </Button>
          </HStack>
        </VStack>
      </Box>
    </Box>
  );

  // Render Wallet Credit Popup
  const renderWalletCreditPopup = () => (
    <Box {...scrollableBoxStyles}>
      {/* Header */}
      <Box bg="linear-gradient(135deg, #48BB78, #38A169)" p={4} color="white" position="relative"> {/* Changed to green gradient */}
        <IconButton
          icon={<X size={20} />}
          position="absolute"
          top={3}
          right={3}
          bg="rgba(255,255,255,0.2)"
          color="white"
          size="sm"
          borderRadius="full"
          onClick={closePopup}
          _hover={{ bg: "rgba(255,255,255,0.3)" }}
        />
        <VStack spacing={1} align="start">
          <Heading size="md" fontWeight="600">Wallet Credit</Heading> {/* Smaller heading */}
          <Text fontSize="xs" opacity={0.9}>Credit to customer app wallet</Text> {/* Smaller text */}
        </VStack>
      </Box>

      {/* Content */}
      <Box p={4}> {/* Reduced padding */}
        <VStack spacing={4} align="stretch"> {/* Reduced spacing */}
          {/* Select Admin Bank */}
          <Box>
            <Text fontSize="sm" fontWeight="600" color="gray.600" mb={2}>Select Admin Bank</Text> {/* Reduced margin */}
            <Select 
              placeholder="Select admin bank account"
              value={selectedAdminBank}
              onChange={(e) => setSelectedAdminBank(e.target.value)}
              bg="white"
              borderColor="gray.300"
              size="sm" // Smaller select
              _focus={{ borderColor: "blue.400", boxShadow: "0 0 0 1px #3182CE" }}
            >
              {bank_list && bank_list.length > 0 ? (
                bank_list
                  .filter((bank) => bank.ac_type?.toLowerCase() !== "cash")
                  .map((bank) => (
                    <option key={bank.id} value={bank.id}>
                      {bank.bankname} ({bank.accountno})
                    </option>
                  ))
              ) : (
                <option disabled>No banks available</option>
              )}
            </Select>
          </Box>

          {/* Customer Details */}
          <Box bg="green.50" p={3} borderRadius="lg" border="2px solid" borderColor="green.200"> {/* Reduced padding */}
            <VStack align="start" spacing={1}>
              <Text fontSize="sm" fontWeight="600" color="green.700">Customer Details</Text>
              <Text fontSize="xs"><strong>Name:</strong> {customerData.name}</Text> {/* Smaller text */}
              <Text fontSize="xs"><strong>Mobile:</strong> {customerData.mobile}</Text> {/* Smaller text */}
            </VStack>
          </Box>

          {/* Credit Amount */}
          <Box>
            <Text fontSize="sm" fontWeight="600" color="gray.600" mb={2}>Credit Amount</Text> {/* Reduced margin */}
            <Box position="relative">
              <Text 
                position="absolute" 
                left={3} 
                top="50%" 
                transform="translateY(-50%)" 
                fontSize="md" 
                fontWeight="600" 
                color="gray.500"
                zIndex={2}
              >
                ₹
              </Text>
              <Input
                pl={7}
                value={refundAmount}
                onChange={(e) => setRefundAmount(e.target.value)}
                type="number"
                step="0.01"
                fontSize="md"
                fontWeight="600"
                textAlign="right"
                bg="white"
                borderColor="gray.300"
                size="sm" // Smaller input
                _focus={{ borderColor: "blue.400", boxShadow: "0 0 0 1px #3182CE" }}
              />
            </Box>
          </Box>

          <HStack spacing={2}> {/* Reduced spacing */}
            <Button 
              flex={1} 
              variant="outline" 
              borderColor="gray.300"
              size="sm" // Smaller button
              onClick={() => setRefundStep('method')}
              leftIcon={<ArrowLeft size={14} />} 
            >
              Back
            </Button>
            <Button 
              flex={1} 
              bg="linear-gradient(135deg, #48BB78, #38A169)" 
              color="white"
              size="sm" // Smaller button
              _hover={{ bg: "linear-gradient(135deg, #38A169, #2F855A)" }}
              onClick={handleWalletCredit}
              isLoading={isProcessing}
            >
              Credit to Wallet
            </Button>
          </HStack>
        </VStack>
      </Box>
    </Box>
  );

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      w="100%"
      h="100%"
      bg="rgba(0,0,0,0.4)"
      backdropFilter="blur(6px)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex="9999"
    >
      {refundStep === 'method' && renderRefundMethodPopup()}
      {refundStep === 'cash' && renderCashRefundPopup()}
      {refundStep === 'online' && renderOnlineTransferPopup()}
      {refundStep === 'wallet' && renderWalletCreditPopup()}
    </Box>
  );
};

export default RefundProcess;